<template>
    <div style="z-index: 0;height:400px;border-radius:8px" class="card pt-0 mb-3 bg-white px-3 py-3">
        <div class="row">
            <h4 class="card-title pl-3 pb-2 mb-0">Transaksi {{nama}}</h4>
        </div>
        <div class="row no-gutters">
            <div class="col-md-1">
                <hr class="border-primary"/>
            </div>
            <div class="col-md-11">
                <hr/>
            </div>
        </div>
        <div id="chart">
            <apexchart type="line" height="300" v-if="status == true" :options="options" :series="series"></apexchart>
            <!-- <apexchart type="donut" height="330" v-if="status == true" :options="chartOptions" :series="series"></apexchart> -->
        </div>
    </div>
</template>

<script>
export default {
    props: ['list', 'listTransaksi', 'listPengajuan', 'userNama'],
    data() {
        return {
            status: false,
            nama: '',
            options: {
                stroke: {
                    curve: 'smooth',
                },
                chart: {
                    id: 'vuechart-example'
                },
                xaxis: {
                    categories: []
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            let value = val.toString()
                            let leng = value.length
                            let sisa 	= leng % 3
                            let rupiah 	= value.substr(0, sisa)
                            let ribuan 	= value.substr(sisa).match(/\d{3}/g)
                                
                            if (ribuan) {
                                let separator = sisa ? '.' : ''
                                rupiah += separator + ribuan.join('.')
                            }
                            return rupiah
                        }
                    },
                },
                zoom: {
                    enabled: false
                },
                color: ['#008FFB', '#D7263D']
            },
            series: []
        }
    },
    watch: {
        list() {
            this.status = false
            this.getData()
        },
    },
    methods: {
        getData() {
            this.options =  {
                stroke: {
                    curve: 'smooth',
                },
                chart: {
                    id: 'vuechart-example'
                },
                xaxis: {
                    categories: this.list
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            let value = val.toString()
                            let leng = value.length
                            let sisa 	= leng % 3
                            let rupiah 	= value.substr(0, sisa)
                            let ribuan 	= value.substr(sisa).match(/\d{3}/g)
                                
                            if (ribuan) {
                                let separator = sisa ? '.' : ''
                                rupiah += separator + ribuan.join('.')
                            }
                            return rupiah
                        }
                    },
                },
                zoom: {
                    enabled: false
                },
                color: ['#008FFB', '#D7263D']
            }
            var i = 0
            var j = 0
            let int = []
            let intt = []
            for(i=0;i<this.listTransaksi.length;i++) {
                int.push(parseInt(this.listTransaksi[i]))
            }
            let inPush = {
                name: 'Total Akses Dashboard',
                data: int,
                color: '#008FFB'
            }
            for(j=0;j<this.listPengajuan.length;j++) {
                intt.push(parseInt(this.listPengajuan[j]))
            }
            let onPush = {
                name: 'Total Pengajuan',
                data: intt,
                color: '#D7263D'
            }
            this.series[0] = inPush
            this.series[1] = onPush
            this.nama = this.userNama
            this.status = true
        }
    },
    mounted() {
    },
}
</script>
<style scoped>
.card-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 1);
    height: 100%;
}
</style>